import React, { CSSProperties, useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as typesProfile from '../../containers/SignInPage/types'
import { checkProfileRole } from '../../utils/helpers'
import * as actions from '../../containers/SignInPage/actions'

// Components
import ModalAwards from '../ModalAwards'

// Styles
import './styles.scss'

export default ({ style }: { style?: CSSProperties }) => {
  const [modal, setModal] = useState<boolean>(false)

  const { profile, certificates, isFetchingCertificates } = useSelector(
    (state: { profile: typesProfile.InitialState }) => state.profile
  )

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.fetchCertificates())
  }, [])

  const isTeacher = checkProfileRole(profile?.roles, 'teacher')

  const hasCertificates =
    certificates && certificates.length && !isFetchingCertificates

  const items = [
    { title: 'Профиль', url: '/profile', type: 'url' },
    { title: 'Родители', url: '/profile/parents', type: 'url' },
    { title: 'Учителя', url: '/profile/teachers', type: 'url' },
    { title: 'Курсы', url: '/profile/courses', type: 'url' },
    { title: 'Конкурсы', url: '/profile/contests', type: 'url' },
    { title: 'Достижения', url: '/profile/achievements', type: 'url' },
    { title: 'Награды', url: '', type: 'button' },
  ]

  return (
    <div style={style}>
      <div
        className={
          isTeacher ? 'profile-header__menu center' : 'profile-header__menu'
        }
      >
        {items
          .filter((_, index) => (isTeacher ? index !== 2 : true))
          .map((link, index) => {
            switch (link.type) {
              case 'url':
                return (
                  <NavLink
                    activeClassName={'active'}
                    className={'profile-header__menu-item'}
                    key={`profile-menu-${index}`}
                    to={link.url}
                    exact={!index}
                  >
                    {link.title}
                  </NavLink>
                )
              case 'button':
                return (
                  <button
                    className={'profile-header__menu-item'}
                    disabled={!hasCertificates}
                    key={`profile-menu-${index}`}
                    onClick={() => setModal(true)}
                  >
                    {link.title}
                  </button>
                )
              default:
                return <></>
            }
          })}
      </div>
      {hasCertificates ? (
        <ModalAwards
          modal={modal}
          close={() => setModal(false)}
          certificates={certificates}
        />
      ) : null}
    </div>
  )
}
